// export const DEFAULT_BROWSER_URL = "http://localhost:3000";
// export const DEFAULT_BACKEND_URL = "http://localhost:4000";
// export const DEFAULT_BROWSER_URL = "https://spiderx.io/";
// export const DEFAULT_BACKEND_URL = "https://api-v1.spiderx.io:4000";


import * as process from "process";

export const DEFAULT_BACKEND_URL = process.env.REACT_APP_NODE_ENV == "dev" ? "https://192.168.100.9:4000" : "https://api-v1.spiderx.io:4000" ;
